import { render, staticRenderFns } from "./InventoryCreate.vue?vue&type=template&id=16e61f3a&scoped=true&"
import script from "./InventoryCreate.vue?vue&type=script&lang=js&"
export * from "./InventoryCreate.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCreate.vue?vue&type=style&index=0&id=16e61f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e61f3a",
  null
  
)

export default component.exports